import BuildingPage from 'pages/BuildingPage';

const AdminOrganizer = (): JSX.Element => <BuildingPage />;

export default AdminOrganizer;
